import Spinner from '@/components/ui/spinner'
import { useFetchClientByCnpjCpf } from '@/features/client/services'
import { PageLayout } from '@/layouts'
import { useParams } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import DadosCliente from '@/features/client/components/dados-cliente'
import ClientInfo from '@/features/client/components/info-clientes'
import AddProduct from '@/features/agreement/components/updateMinutaProduct'
import ProductFlow from '@/features/products/components/ProductFlow'

export default function ClientesPage() {
  const params = useParams<{ cnpjcpf: string }>()
  const { data: clientData, isLoading } = useFetchClientByCnpjCpf(params.cnpjcpf)
  // const navigate = useNavigate()

  if (!clientData || isLoading) {
    return (
      <div className="w-full flex items-center justify-center h-screen">
        <Spinner size="large" />{' '}
      </div>
    )
  }

  // const idTenant = clientData?.id_tenant
  // const logoSrc = `/${idTenant}.svg`

  return (
    <PageLayout
      // estava ocupando muito espaço, então removi Porem alterei pra receber react tambem
      //  title={<span className="text-lg md:text-xl text-muted-foreground">Cliente</span>}
      description={
        <header>
          <div className="flex flex-col sm:flex-row items-center justify-between py-2">
            {/* <img onClick={() => navigate(-1)} src={logoSrc} alt="LOGO" className="h-20 max-w-xs hidden md:block" /> */}
            <div className="flex-1 sm:flex sm:justify-between sm:items-center">
              <div className="flex flex-row justify-center sm:justify-start space-x-2">
                <DadosCliente clientData={clientData} />
              </div>
            </div>
          </div>
        </header>
      }
    >
      <div className=" shadow overflow-hidden sm:rounded-lg ">
        <Tabs defaultValue="info">
          <TabsList>
            <TabsTrigger value="info">Informações</TabsTrigger>
            {/* <TabsTrigger value="products">Produtos</TabsTrigger> */}
            <TabsTrigger value="add">Adicionar Produto</TabsTrigger>
          </TabsList>
          <TabsContent value="info">
            <ClientInfo initialClientData={clientData} />
          </TabsContent>
          <TabsContent value="products">
            <ProductFlow />
          </TabsContent>
          <TabsContent value="add">
            <AddProduct id_client={params.cnpjcpf!} />
          </TabsContent>
        </Tabs>
      </div>
    </PageLayout>
  )
}
